import type { UseFormReturn } from "react-hook-form";
import { Button } from "./ui/button";

import type { IzCampaignFormAdmin } from "../z/admin/campaign-form.admin.z";
import { FormSwitch } from "./form-components/form-switch.components";
import { useNavigate } from "react-router-dom";
import { useToast } from "../hooks/use-toast";

type FixedPayoutsProps = {
	form: UseFormReturn<IzCampaignFormAdmin>; // Use the specific form type
};

const FixedPayouts = ({ form }: FixedPayoutsProps) => {
	const navigate = useNavigate();
	const { toast } = useToast();
	const handleManage = () => {
		if (window.location.pathname.includes("edit")) {
			return navigate("add-fixed-payouts");
		}
		toast({
			toastType: "info",
			content: "Fixed payouts can be managed only after campaign creation",
		});
	};
	return (
		<div
			className={
				"flex flex-col px-8 py-7 pb-6 border border-border rounded-xl w-full "
			}
		>
			<div className="flex justify-between items-center w-full font-semibold">
				<p>Fixed payouts</p>
				<div className="flex items-center gap-5">
					<Button
						type="button"
						disabled={!form.getValues("hasFixedPayout")}
						onClick={handleManage}
						className="bg-tertiarybuttonbg border border-border font-semibold"
					>
						Manage
					</Button>
					<FormSwitch form={form} name="hasFixedPayout" />
				</div>
			</div>
		</div>
	);
};

export default FixedPayouts;
